import { FormConfigurationActionTypes, FormConfigurationActions } from './form-configuration.actions';
import { IFormConfiguration } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IFormConfiguration | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: FormConfigurationActions): State {
    switch (action.type) {

        case FormConfigurationActionTypes.LoadFormConfigurationState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case FormConfigurationActionTypes.LoadFormConfigurationStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case FormConfigurationActionTypes.SaveFormConfiguration: {
            return {
                error: null,
                pending: true,
                stateData: action.payload
            };
        }


        case FormConfigurationActionTypes.SaveFormConfigurationSuccess: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case FormConfigurationActionTypes.LoadFormConfigurationStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case FormConfigurationActionTypes.FormConfigurationScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;